// extracted by mini-css-extract-plugin
module.exports = {"layout":"page_40mm_28mm_1_label_layout__yupra"};